import { identity, property } from 'lodash';
import { useCallback } from 'react';

const defaultExtract = property(['target', 'value']);

/**
 * Transforms the given `setState` function into a DOM event callback,
 *  e.g. for use in a text field.
 * @template T
 * @param {React.Dispatch<React.SetStateAction<T>>} setState
 * @param {Object} [options]
 * @param {(value: string) => T} [options.transform]
 * @param {(event: Event) => T} [options.extract]
 * @returns {React.ChangeEventHandler<{ value: T }>}
 */
export default function useChangeEvent(setState, { transform = identity, extract = defaultExtract } = {}) {
    return useCallback(event => {
        let value = extract(event);

        value = transform(value);

        setState(value);
    }, [setState, transform, extract]);
}